import LogoMark from "../../assets/img/logo-2mm-sans-texte.png";

// Pourquoi ce fichier : le filigrane des bandeaux (écrans candidat, page d'une vidéo) ; une seule copie évite
// qu'ils divergent. Nicolas (01/11) : l'anneau dessiné faisait basique, il demandait la partie image du logo.
// C'est le fichier officiel (logo sans texte), jamais redessiné (charte) : seule l'opacité change, en CSS.
const BandDeco = () => <img className="cand-deco" src={LogoMark} alt="" />;

export default BandDeco;
